module.exports = __webpack_public_path__ + "img/7.0_News_2_Scott-Wilson@2x.cb29e90825535ac56521c43394fccae6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/7.0_News_2_Scott-Wilson@2x.png
// module id = 797
// module chunks = 0